// @flow
export default {
  cart: {
    display: 'flex',
    flexDirection: 'row',
    margin: '0px 12px'
  },
  cartMobile: {
    margin: '0px 8px'
  },
  hyperlink: {
    display: 'flex',
    flexDirection: 'row',
    textDecoration: 'none',
    alignItems: 'center',
    color: 'black'
  },
  buyButton: (color: string) => ({
    marginLeft: '12px',
    height: '1rem',
    padding: '0.1rem 0.85rem',
    border: `1px solid ${color}`
  }),
  buyButtonText: {
    fontSie: 15,
    lineHeight: '1rem'
  },
  priceAndCart: {
    display: 'flex',
    alignItems: 'center'
  },
  price: (color: string) => ({
    fontSize: '1rem',
    marginLeft: '8px',
    color
  })
}
